import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.foodOperator.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.foodOperator.fields.name'),
  },
  {
    name: 'address',
    label: i18n('entities.foodOperator.fields.address'),
  },
  {
    name: 'country',
    label: i18n('entities.foodOperator.fields.country'),
  },
  {
    name: 'operatorType',
    label: i18n('entities.foodOperator.fields.operatorType'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.foodOperator.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.foodOperator.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
